module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-sider"
  }, [_c('el-container', [_c('el-aside', {
    staticStyle: {
      "background-color": "#283340"
    },
    attrs: {
      "width": _vm.siderWidth
    }
  }, [_c('div', {
    staticClass: "page-sidebar-container"
  }, [_c('div', {
    staticClass: "page-sidebar",
    class: {
      collapse: _vm.collapse
    },
    style: (_vm.sidebarHeight)
  }, [_c('el-menu', {
    attrs: {
      "mode": "vertical",
      "default-active": "1",
      "router": true
    }
  }, [_c('li', {
    staticClass: "el-menu-item page-sidebar-toggle-btn",
    style: (_vm.styleObject),
    on: {
      "click": function($event) {
        _vm.collapseChange()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left",
    class: {
      'fa-angle-left': !_vm.collapse, 'fa-angle-right': _vm.collapse
    }
  })]), _vm._v(" "), _vm._l((_vm.sidebarMenus), function(menu) {
    return _c('el-menu-item', {
      key: menu.index,
      staticClass: "page-menu-item",
      class: {
        active: _vm.activeMenu === menu.index
      },
      style: (_vm.styleObject),
      attrs: {
        "index": menu.index,
        "route": menu
      }
    }, [_c('i', {
      class: menu.icon
    }), _vm._v(" "), _c('span', {
      staticClass: "page-menu-item-title"
    }, [_vm._v("\n                            " + _vm._s(menu.title) + "\n                        ")]), _vm._v(" "), (menu.alarmCount && !_vm.collapse) ? _c('el-badge', {
      attrs: {
        "value": menu.alarmCount,
        "type": menu.name === 'unable_failover_jobs' ? 'warning' : 'danger'
      }
    }) : _vm._e()], 1)
  })], 2)], 1)])]), _vm._v(" "), _c('el-main', [_vm._t("default")], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5730ad78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/aside.vue
// module id = 1412
// module chunks = 1